export const createSelectEntitySlice = set => ({
  selectedEntities: [],
  selectedGroups: [],
  clearSelectedEntities: () => set(() => ({ selectedEntities: [] })),
  clearSelectedGroups: () => set(() => ({ selectedGroups: [] })),

  setSelectedEntities: values =>
    set(() => ({
      selectedEntities: values
    })),
  setSelectedGroups: values =>
    set(() => ({
      selectedGroups: values
    })),

  selectEntities: values =>
    set(state => {
      const entities = [...values];
      const selectedEntities = [...state.selectedEntities];
      entities.forEach(entity => {
        if (!selectedEntities.find(e => e.id === entity.id)) {
          selectedEntities.push(entity);
        } else {
          const index = selectedEntities.findIndex(e => e.id === entity.id);
          if (index >= 0) {
            selectedEntities.splice(index, 1);
          }
        }
      });
      return { selectedEntities };
    }),

  selectGroups: values =>
    set(state => {
      const entities = [...values];
      const selectedGroups = [...state.selectedGroups];
      entities.forEach(entity => {
        if (!selectedGroups.find(e => e.id === entity.id)) {
          selectedGroups.push(entity);
        } else {
          const index = selectedGroups.findIndex(e => e.id === entity.id);
          if (index >= 0) {
            selectedGroups.splice(index, 1);
          }
        }
      });
      return { selectedGroups };
    }),

  addSelectedEntities: values =>
    set(state => ({
      selectedEntities: [...state.selectedEntities, ...values]
    })),

  removeSelectedEntities: values =>
    set(state => ({
      selectedEntities: state.selectedEntities.filter(
        s => !values.find(o => o.id === s.id)
      )
    })),
  removeSelectedGroups: values =>
    set(state => ({
      selectedGroups: state.selectedGroups.filter(
        s => !values.find(o => o.id === s.id)
      )
    }))
});
